<template>
	<b-container class="justify-content-md-center">
		<b-card>
			<b-card-body title="Trino Console">
				<b-form @submit="login">
					<b-row>
						<b-col>
							<b-form-group id="username-group" label="Username:" label-for="username" description="The username is usually your email address ">
								<b-form-input id="username" type="text" v-model="username" autofocus required placeholder="Enter username"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group id="password-group" label="Password:" label-for="password" description="">
								<b-form-input id="password" type="password" v-model="password" required placeholder="Enter password"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form>
				<span class="float-right">
					<b-button variant="primary" @click="login()">Login</b-button>
				</span>
			</b-card-body>
		</b-card>
	</b-container>
</template>

<script>
import {authenticationService} from '../../services/AuthenticationService'

export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  methods: {
    login () {
      if ((this.username === '') || (this.password === '')) {
        this.error = 'Username and password is required!'
        return
      }
      authenticationService.authenticate(this.username, this.password)
        .then(data => {
          console.log('authentication successful')
          this.$router.push('/home')
        }).catch(e => {
          console.log('authentication error')
          this.error = 'Invalid credentials, please try again'
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Invalid credentials, please verify your username and password is correct'
          })
        })
    }
  },
  created () {
  }
}
</script>
<style scoped>
body {
    background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// LoginPage.vue?da898d04